// extracted by mini-css-extract-plugin
export default {"container":"Error_container__1PCzv","iconContainer":"Error_iconContainer__OCDzR","title":"Error_title__TvtAI","actionButton":"Error_actionButton__6jc7V"};